import { Divider, DividerProps } from '@mui/material';
import { JSX } from 'react';

export const HBDivider = (props: DividerProps): JSX.Element => {
  const { sx, ...other } = props;
  return <Divider sx={{ borderColor: 'grey.100', ...sx }} {...other} />;
};
